import { features } from '@/mocks/categories';

export default function FeatureGrid() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-background-300/60 text-foreground-600 text-xs font-semibold uppercase tracking-wider mb-4">
            Why Kakobuy Spreadsheet
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Save Research Time.
            <br />
            Shop Smarter.
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Our spreadsheet database is built to make your shopping experience faster, safer, and more enjoyable.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 md:p-8 rounded-2xl border border-background-200/70 bg-background-50 hover:bg-primary-50/50 transition-colors duration-300 cursor-default"
            >
              <div className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center mb-5">
                <i className={`${feature.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}